import { defineStore } from 'pinia';

export const woningStore = defineStore({
  id: 'woning',
  state: () => ({
    bouwaarddak: '',
    bouwaardmuren: '',
    certificaatrietendakaanwezig: '1',
    constructierietendak: '',
    gebruik: '',
    hoedanigheid: '',
    herbouwwaarden: '',
    huidigestatus: '',
    huisnummer: '',
    huisnummertoevoegsel: '',
    inboedelwaarde: '',
    inhoud: '',
    onderhoudsstaat: '',
    plaats: '',
    postcode: '',
    straat: '',
    toevoeging: '',
    toevoegingenOpties: [],
    type: '',
    verbouwing: '0',
    woonoppervlakte: '',
    bouwjaar: '',
    staatoprecreatiepark: '',
    naamrecreatiepark: '',
    adresrecreatiepark: '',
    locatierecreatiepark: '',
    gasvoorzieningen: '',
    gasvoorzieningenanders: '',
    elektravoorzieningen: '',
    elektravoorzieningenanders: '',
    recreatiewoningbewoond: '',
    monument: '',
    residentie: '',
    verhuur: '',
  }),
  getters: {},
  actions: {},
  persist: true,
});
